import React from 'react';
import styles from './SelectedOptionList.scss';
import classnames from 'classnames';

export const SelectedOptionList = (props) => (
    <ul className={styles.selectOptionList} data-cy="SelectedOptionList">
        {props.children}
    </ul>
);

export const SelectedOptionCard = (props) => (
    <li data-cy="SelectedOptionCard">
        {props.children}
    </li>
);

export const SelectedOptionLabels = (props) => (
    <div className={styles.selectedOptionLabels} data-cy="SelectedOptionLabels">
        <p
            className={
                classnames(
                    styles.selectedOptionPrimaryLabel, {
                        [styles.selectedOptionEllipsis]: props.withEllipsis,
                        [styles.selectedOptionDisabled]: props.isDisabled
                    }
                )
            }
            data-cy="SelectedOptionList-Label"
        >
            {props.primaryLabel}
        </p>
        {
            !!props.secondaryLabel &&
                <p className={styles.selectedOptionSecondaryLabel} data-cy="SelectedOptionList-secondaryLabel">
                    {props.secondaryLabel}
                </p>
        }
    </div>
);

export const SelectedOptionAction = (props) => (
    <a
        className={classnames(styles.selectedOptionAction, props.className)}
        onClick={props.onClick}
        data-cy="SelectedOptionList-SelectedOptionAction"
    >
        {props.children}
    </a>
);

export const SelectedOptionLeftColumn = (props) => (
    <div className={styles.selectedOptionLeftColumn} data-cy="SelectedOptionList-SelectedOptionLeftColumn">
        {props.children}
    </div>
);

export const SelectedOptionRightColumn = (props) => (
    <div className={styles.selectedOptionRightColumn} data-cy="SelectedOptionList-SelectedOptionRightColumn">
        {props.children}
    </div>
);
